// Auto-generate grid-based layouts for equipment
import { PORT, GRID } from './portLayout';
import { SimpleLayout } from '../types';

// Template size selection based on port count
type PresetTemplateSize = 'desktopTiny' | 'desktopSmall' | 'desktop' | 'rack' | 'rackLong' | 'rackShort';

const PRESET_TEMPLATES: Record<PresetTemplateSize, { cols: number; rows: number }> = {
  desktopTiny: { cols: 5, rows: 1 },
  desktopSmall: { cols: 8, rows: 1 },
  desktop: { cols: 12, rows: 2 },
  rack: { cols: 24, rows: 2 },
  rackLong: { cols: 24, rows: 2 },
  rackShort: { cols: 16, rows: 2 },
};

// Actual port dimensions (matching SimpleLayoutEditor)
const ACTUAL_PORT_WIDTH = 18;
const ACTUAL_PORT_GAP = GRID; // Use GRID constant from portLayout (6px)

/**
 * Auto-generate a grid-based layout for equipment based on port count
 * This creates a SimpleLayout with RJ45 ports arranged in a grid
 */
export const autoGenerateGridLayout = (portCount: number): SimpleLayout => {
  // Determine appropriate template size based on port count
  let templateSize: PresetTemplateSize;
  if (portCount <= 5) {
    templateSize = 'desktopTiny';
  } else if (portCount <= 8) {
    templateSize = 'desktopSmall';
  } else if (portCount <= 16) {
    templateSize = 'desktop';
  } else if (portCount <= 24) {
    templateSize = 'rack';
  } else {
    templateSize = 'rackLong';
  }

  const template = PRESET_TEMPLATES[templateSize];
  
  // Create grid with RJ45 ports filled in
  const ports: any[] = [];
  const padding = 18;
  const stageWidth = template.cols * (ACTUAL_PORT_WIDTH + ACTUAL_PORT_GAP) - ACTUAL_PORT_GAP + 36;
  const stageHeight = template.rows * (PORT.height + ACTUAL_PORT_GAP) - ACTUAL_PORT_GAP + 44;
  const startY = Math.round((stageHeight - (template.rows * (PORT.height + ACTUAL_PORT_GAP) - ACTUAL_PORT_GAP)) / 2);

  let portNumber = 1;
  
  // Fill grid left-to-right, top-to-bottom with RJ45 ports
  for (let row = 0; row < template.rows && portNumber <= portCount; row++) {
    for (let col = 0; col < template.cols && portNumber <= portCount; col++) {
      const x = padding + col * (ACTUAL_PORT_WIDTH + ACTUAL_PORT_GAP);
      const y = startY + row * (PORT.height + ACTUAL_PORT_GAP);
      
      ports.push({
        id: `p-${portNumber}`,
        number: portNumber,
        kind: 'rj45' as const,
        x,
        y,
        flipped: row > 0,
      });
      
      portNumber++;
    }
  }

  return {
    stage: { width: stageWidth, height: stageHeight },
    ports,
    templateSize, // Save template size for later editing
  };
};

